import { Injectable } from '@angular/core';

import type { QuotaStatusResponse } from '@reach/interfaces/quotas/quota.responses';

import { BaseApiService } from '~ng-common-lib/core/api/base.api.service';

@Injectable({ providedIn: 'root' })
export class QuotaApiService extends BaseApiService {
	protected override commonPath = ['nodes'];

	public async getQuota(): Promise<QuotaStatusResponse> {
		return await this.http.get<QuotaStatusResponse>(this.url(), {
			t: this.paramTime,
		});
	}
}
